document.addEventListener("DOMContentLoaded", function () {
    const newsletterDelay = 30000;
    const newsletter = document.querySelector(".advene-newsletter");
    const newsletterCloseButton = document.querySelector(
        ".advene-newsletter__close"
    );

    newsletterCloseButton.addEventListener("click", () => {
        newsletter.style.display = "none";
    });

    setTimeout(() => {
        newsletter.classList.add("active");
    }, newsletterDelay);
});
